"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyController = function () {
  function SurveyController(SurveyService, FilterService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, SurveyController);
    this.surveyService = SurveyService;
    this.filterService = FilterService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  (0, _createClass3.default)(SurveyController, [{
    key: "$onInit",
    value: function $onInit() {
      this.surveyResponseOptions = {
        dataSource: [{ value: 1, text: "Yes" }, { value: 2, text: "No" }, { value: 3, text: "NA" }],
        dataTextField: "text",
        dataValueField: "value"
      };
    }
  }, {
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      debugger;
      return {
        dataSource: this.surveyService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
        sortable: true,
        pageable: true,
        resizable: true,
        height: "90vh",
        noRecords: {
          template: "No match found. Change your filter criteria."
        },
        columns: [{ field: "responseDate", title: "Date", template: "<span>#= kendo.toString(new Date(responseDate), 'dd-MM-yyyy') #</span>", filterable: false, width: "6rem" }, { title: "Name", template: "<a class=\"cell\" href=\"#= '/users/' + jugglerId #\">#= fullName #</a>", filterable: false, sortable: false, width: "10rem" }, { field: "jugglerType", title: "Type", filterable: false, sortable: true, width: "4rem", template: function template(dataItem) {
            return "" + _this._getJugglerType(dataItem.jugglerType);
          } }, { field: "email", title: "Email", filterable: false, sortable: false, width: "8rem" }, { field: "interestInHomeAgedCareResponse", title: "Response", filterable: false, sortable: true, width: "8rem", template: function template(dataItem) {
            return "" + _this._getSurveyResponse(dataItem.interestInHomeAgedCareResponse);
          } }]
      };
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.surveyMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this2 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this2.applyFilters();
        }).catch(function (error) {
          _this2.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }, {
    key: "_getSurveyResponse",
    value: function _getSurveyResponse(status) {
      switch (status) {
        case _constants2.default.surveyResponse.YES:
          return "Yes";
        case _constants2.default.surveyResponse.NO:
          return "No";
        case _constants2.default.surveyResponse.NA:
          return "NA";
      }
    }
  }, {
    key: "_getJugglerType",
    value: function _getJugglerType(status) {
      switch (status) {
        case _constants2.default.jugglerType.PARENT:
          return "Family";
        case _constants2.default.jugglerType.HELPER:
          return "Helper";
      }
    }
  }]);
  return SurveyController;
}();

exports.default = SurveyController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/survey/survey.controller.js
 **/